import React, { useState} from "react";
import '../../components/AccountManagement/Accounts.css';
import inputStyles from '../ManagementPages.module.css';
import { useSelector } from 'react-redux';
import { customStyles } from "../../components/AccountManagement/CustomStyles";
import Select from 'react-select';

const ActivateEmergencyContact = ({userData, handleChange}) => {

     const dropdowns = useSelector((state) => state.dropdowns);

    const [displayPhoneCountryCode, setDisplayPhoneCountryCode] = useState(() => {
        const countryCodeMatch = dropdowns.countries.find((code)=>code.phoneCountryCode === userData.emergencyContact.countryCode)
        if (countryCodeMatch && userData.emergencyContact.countryCode !== "") {
            return {value: countryCodeMatch.phoneCountryCode, label: `${countryCodeMatch.phoneCountryCode} (${countryCodeMatch.name})`}
        } else return {value:'', label: ''}
    });

    const [displayCountry, setDisplayCountry] = useState(() => {
        const selectedCountry = dropdowns.countries.find(country => country.code === userData.emergencyContact.country);
        return selectedCountry ? { value: selectedCountry.code, label: selectedCountry.name } : { value: '', label: '' };
    });
    
    const [displayState, setDisplayState] = useState(() => {
        const selectedCountry = dropdowns.countries.find(country => country.code === userData.emergencyContact.country);
        const selectedState = selectedCountry?.states.find(state => state.code === userData.emergencyContact.state);
        return selectedState ? { value: selectedState.code, label: selectedState.name } : { value: '', label: '' };
    });

    const handlePhoneCountryCode = (selected) => {
        handleChange({value: selected.value},'countryCode', 'emergencyContact');
        setDisplayPhoneCountryCode(selected);
    };

    const handleCountry = (selected) => {
        handleChange({value: selected.value},'country', 'emergencyContact');
        handleChange({value: ''},'state', 'emergencyContact');
        setDisplayState({ value: '', label: '' })
        setDisplayCountry(selected);
    };

    const handleState = (selected) => {
        handleChange({value: selected.value},'state', 'emergencyContact');
        setDisplayState(selected);
    };

    return (
        <div className="personal-info-container">
            <div className="personal-info-content">
                <div className={inputStyles["styled-input-container"]}>
                    <input
                        id="fullName"
                        style={{width:"300px"}}
                        value={userData.emergencyContact.fullName}
                        onChange={(e)=>handleChange(e,null,"emergencyContact")}
                    ></input>
                    <label className={userData.emergencyContact.fullName && inputStyles['filled']}>
                        Emergency Contact Full Name
                    </label>
                </div>
                <div style={{position: "relative"}}>
                    <span className="floating-label">Relationship</span>
                    <select
                        className={inputStyles["styled-input-select"]}
                        id="relation"
                        style={{width:"300px"}}
                        value={userData.emergencyContact.relation}
                        onChange={(e)=>handleChange(e,null,"emergencyContact")}
                    >
                        <option value="">Select a Relationship</option>
                        {dropdowns.relationship.values.map((type) => (
                            <option key={type.id} value={type.id}>
                                {type.display}
                            </option>
                        ))}
                    </select>
                </div>
                <div style={{position: "relative"}}>
                    <span className="floating-label">Gender</span>
                    <select
                        className={inputStyles["styled-input-select"]}
                        id="gender"
                        style={{width:"300px"}}
                        value={userData.emergencyContact.gender}
                        onChange={(e)=>handleChange(e,null,"emergencyContact")}
                    >
                        <option value="">Select a Gender</option>
                        {dropdowns.gender.values.map((type) => (
                            <option key={type.id} value={type.id}>
                                {type.display}
                            </option>
                        ))}
                    </select>
                </div>
                <div style={{display:"flex",width: "300px",justifyContent:"space-between", height:"44px"}}>
                    <div style={{position: "relative", width: "40%"}}>
                        <span className={"floating-label"} style={{zIndex:"1"}}>Country Code*</span>
                        <Select
                            options={dropdowns.countries.map((code) => {
                                return ({
                                    label: `${code.phoneCountryCode} (${code.name})`,
                                    value: code.phoneCountryCode
                                })
                            })}
                            styles={{
                                ...customStyles.popup,
                                container: (provided) => ({
                                    ...provided,
                                    width: '100%',
                                }),
                            }}
                            value={displayPhoneCountryCode}
                            placeholder='Code*'
                            isSearchable={true}
                            onChange={handlePhoneCountryCode}
                        />
                    </div>
                    <div className={inputStyles["styled-input-container"]} style={{width:"58%"}}>
                        <input
                            style={{width:"100%"}}
                            id="phone"
                            value={userData.emergencyContact.phone}
                            onChange={(e)=>handleChange(e,null,"emergencyContact")}
                        ></input>
                        <label className={userData.emergencyContact.phone && inputStyles['filled']}>
                            Phone Number
                        </label>
                    </div>
                </div>
                <div className={inputStyles["styled-input-container"]}>
                    <input
                        id="email"
                        type="email"
                        style={{width:"300px"}}
                        value={userData.emergencyContact.email}
                        onChange={(e)=>handleChange(e,null,"emergencyContact")}
                    ></input>
                    <label className={userData.emergencyContact.email && inputStyles['filled']}>
                        Email
                    </label>
                </div>
                <div className={inputStyles["styled-input-container"]}>
                    <input
                        id="address1"
                        style={{width:"300px"}}
                        value={userData.emergencyContact.address1}
                        onChange={(e)=>handleChange(e,null,"emergencyContact")}
                    ></input>
                    <label className={userData.emergencyContact.address1 && inputStyles['filled']}>
                    Street Address
                    </label>
                </div>
                <div className={inputStyles["styled-input-container"]}>
                    <input
                        id="address2"
                        style={{width:"300px"}}
                        value={userData.emergencyContact.address2}
                        onChange={(e)=>handleChange(e,null,"emergencyContact")}
                    ></input>
                    <label className={userData.emergencyContact.address2 && inputStyles['filled']}>
                    Apartment, Suite, etc
                    </label>
                </div>
                <div style={{display:"flex", flexDirection:"column", width: "300px"}}>
                    <div className="input-block" style={{width: "100%"}}>
                        <div style={{position: "relative", width: "49%"}}>
                            <span className={"floating-label"} style={{zIndex:"1"}}>Country</span>
                            <Select
                                options={dropdowns.countries.map((country) => {
                                    return ({
                                        label: country.name,
                                        value: country.code
                                    })
                                })}
                                styles={{
                                    ...customStyles.popup,
                                    container: (provided) => ({
                                        ...provided,
                                        width: '100%',
                                    }),
                                }}
                                value={displayCountry}
                                placeholder='Country'
                                isSearchable={true}
                                onChange={handleCountry}
                            />
                        </div>
                        <div style={{position: "relative", width: "49%"}}>
                            <span className={"floating-label"} style={{zIndex:"1"}}>State</span>
                                <Select
                                    options={
                                        displayCountry.value
                                            ? dropdowns.countries
                                                    .find(country => country.code === displayCountry.value)
                                                    ?.states.map(state => ({
                                                        label: state.name,
                                                        value: state.code
                                                    })) || []
                                            : []
                                    }
                                    styles={{
                                        ...customStyles.popup,
                                        container: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                        }),
                                    }}
                                    value={displayState}
                                    placeholder='State'
                                    isSearchable={true}
                                    onChange={handleState}
                                />
                        </div>
                    </div>
                    <div className="input-block" style={{marginBottom:"0px", width: "100%"}}>
                        <div className={inputStyles["styled-input-container"]} style={{width:"49%"}}>
                            <input
                                type="text"
                                style={{width:"100%"}}
                                id="city"
                                value={userData.emergencyContact.city}
                                onChange={(e)=>handleChange(e, "city", "emergencyContact")}
                            ></input>
                            <label className={userData.emergencyContact.city && inputStyles['filled']}>
                            City
                            </label>
                        </div>
                        <div className={inputStyles["styled-input-container"]} style={{width:"49%"}}>
                            <input
                                type="text"
                                style={{width:"100%"}}
                                id="zip"
                                value={userData.emergencyContact.zip}
                                onChange={(e)=>handleChange(e, "zip", "emergencyContact")}
                            ></input>
                            <label className={userData.emergencyContact.zip && inputStyles['filled']}>
                            Postal Code
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default ActivateEmergencyContact;